import { render, staticRenderFns } from "./Retailer.vue?vue&type=template&id=cf27a2ee&"
import script from "./Retailer.vue?vue&type=script&lang=js&"
export * from "./Retailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports